import { takeEvery, fork, put, all, call, takeLatest, select, take, delay, actionChannel } from "redux-saga/effects";
import { buffers } from "redux-saga";
import { WpActionTypes, WpPostInfo } from "./wpTypes";
import { Utils } from "helpers/utils";
import {
  loadPostTitleApiV2, loadPostConverApi2, loadPostInfoApi, getRoleUnreadCountApi, loadDllEmployeeApi, loadTaskDashApiV2,
  loadSubTaskApi,
  loadTaskDashTagsApiV2, loadTaskDashboardByDivApi, tagMasterCatLoadApi,
  loadTaskDashRecuranceApi,
  loadTaskDashStatusrangeV2Api
} from "../../api/wpapi";

import { loadPostInfo, setPostInfoOnly, setActivePostId2 } from "./wpActions";
import { apiOk, apiErr } from "../workplace/wpActions";
import { DbUtils } from "helpers/dbUtils";
import { TABS, WpModes } from "../../constants";
import { StorageUtils } from "helpers/storageutils";

const WP_CONVER_PAGE_SIZE = 50;

/* saga function */
function* loadPostTitleSaga({ type, payload:
  { wpMode, keyword, tagSet, memberRole, tagIds, filterUnRead, filterNotClose, empFilterType, tagCatMatchedAll, callFrom, taskStatus
    , filterFromDash, taskResponder, taskAssigner, taskRequester
    , taskRange1, taskRange2, includeTaskRecurance, filterTaskDueMode, sortMode, taskRangeFilter, taskPriorityFilter
  } }: any): Generator<any, void, any> {
  try {
    // console.log('loadPostTitleSaga:', {
    //   wpMode, keyword, tagSet, memberRole, tagIds, filterUnRead, filterNotClose, empFilterType, tagCatMatchedAll, callFrom, taskStatus
    //   , filterFromDash, taskResponder, taskAssigner, taskRequester
    //   , taskRange1, taskRange2, includeTaskRecurance, filterTaskDueMode
    // });
    const isLoadFromStarup = !keyword && tagSet.length <= 0 && (tagIds ?? []).length <= 0 && filterUnRead == false && filterNotClose == true && empFilterType == 1 && (tagCatMatchedAll ?? []).length <= 0;
    if (isLoadFromStarup) {
      try {
        const rs: any[] = yield call(DbUtils.wp_load_post_title, wpMode, null);
        // console.log('put title from storage:', rs);
        if (rs != null) {
          yield put(apiOk(type, { wpMode, titles: rs }));
        }
      } catch (e2) {
        Utils.HandleException(e2, false);
      }
    }
    // console.log('loadPostTitleSaga:', { keyword, tagSet, memberRole, tagIds, filterUnRead, filterNotClose, empFilterType, tagCatMatchedAll, isLoadFromStarup });
    // Scoped by wpMode - Workplace's and Task's title loads run concurrently on mount/redirect,
    // and previously shared one unscoped flag, so whichever finished first could clear it before
    // the other (unrelated) mode's load ever saw it, leaving the real target unprotected.
    const redirectWpId = Utils.GetRedirectPostId(wpMode);
    // console.log('setActivePostId saga load - start ' + wpMode);
    const includePostIds: string[] = redirectWpId ? [redirectWpId] : [];
    // 20261021 deep-search flag was stamped onto lastTitleQuery by the reducer when this action ran
    const wpState: any = yield select((state: any) => state.WpSlice);
    const deepSearch: boolean = !!(wpMode == WpModes.Workplace ? wpState.lastTitleQueryWp : wpState.lastTitleQueryTk)?.deepSearch;
    //const response: Promise<any> = yield call(loadPostTitleApi, keyword, tagSet, memberRole, tagIds, filterUnRead, filterNotClose, empFilterType, includePostIds, tagCatMatchedAll);
    const response: any[] = yield call(loadPostTitleApiV2, wpMode, keyword, tagSet, memberRole, tagIds, filterUnRead, filterNotClose, empFilterType, includePostIds, tagCatMatchedAll, callFrom
      , taskStatus, filterFromDash, taskResponder, taskAssigner, taskRequester, taskRange1, taskRange2, includeTaskRecurance, filterTaskDueMode, sortMode
      , null, null, null, null, null, taskRangeFilter, null, taskPriorityFilter, deepSearch); // 20250815
    // console.log('setActivePostId saga load - done ' + wpMode );
    // Deliberately NOT clearing the flag here even though this fetch just consumed it - it's a
    // time-windowed guard (see Utils.SetRedirectPostId), not single-use. WorkplaceTitle.tsx and
    // Chats/index.tsx read the same flag to decide whether to protect the active post from their
    // own unrelated mount-time "clear as a side effect" bootstrap effects, and clearing it as soon
    // as this fetch used it left them unprotected whenever they happened to run afterward - an
    // ordering that flips with real network latency. Let it expire on its own.
    if (isLoadFromStarup) {
      DbUtils.wp_load_post_title(wpMode, response);
    }
    //  console.log('loadPostTitleSaga:', response);

    // 20250815 make draft flag
    const draftPostIds = Utils.WpDraft_GetAllPostId();
    for (const item of response) {
      item.draft = draftPostIds.includes(item.postId);
    }

    yield put(apiOk(type, { wpMode, titles: response }));
  } catch (e) {
    Utils.HandleException(e, true); // 20250430 เปลี่ยนเป็น true ชั่วคราว เพื่อดู error
    yield put(apiErr(type, Utils.GetMessageFromExecption(e)));
  }
}

function* loadMorePostTitleSaga({ type, payload: { wpMode } }: any): Generator<any, void, any> {
  try {
    const wp: any = yield select((state: any) => state.WpSlice);
    const isWp = wpMode == WpModes.Workplace;
    const lastQuery = isWp ? wp.lastTitleQueryWp : wp.lastTitleQueryTk;
    const titles = isWp ? wp.titles : wp.titlesTk;
    const hasMore = isWp ? wp.titleHasMoreWp : wp.titleHasMoreTk;
    // no prior search to replay, list is empty, dashboard-filtered list (out of scope - see loadPostTitleSaga's isLoadFromStarup), or already known to be the last page
    if (!lastQuery || lastQuery.filterFromDash || titles.length === 0 || !hasMore) {
      yield put(apiOk(type, { wpMode, moreTitles: [] }));
      return;
    }
    const lastTitle = titles[titles.length - 1];
    const response: any[] = yield call(loadPostTitleApiV2, wpMode, lastQuery.keyword, lastQuery.tagSet, lastQuery.memberRole, lastQuery.tagIds, lastQuery.filterUnRead, lastQuery.filterNotClose
      , lastQuery.empFilterType, [], lastQuery.tagCatMatchedAll, "LoadMorePostTitle"
      , lastQuery.taskStatus, false, lastQuery.taskResponder, lastQuery.taskAssigner, lastQuery.taskRequester, lastQuery.taskRange1, lastQuery.taskRange2, lastQuery.includeTaskRecurance, lastQuery.filterTaskDueMode, lastQuery.sortMode
      , lastTitle.postId, lastTitle.lastChatDateEpochMs, lastTitle.planFinishedDateEpochMs, lastTitle.taskStatus, lastTitle.responderName
      , null, lastTitle.priority, null, !!lastQuery.deepSearch);

    const draftPostIds = Utils.WpDraft_GetAllPostId();
    for (const item of response) {
      item.draft = draftPostIds.includes(item.postId);
    }

    yield put(apiOk(type, { wpMode, moreTitles: response }));
  } catch (e) {
    Utils.HandleException(e, true);
    yield put(apiErr(type, Utils.GetMessageFromExecption(e)));
  }
}

// function* loadPostConverSaga({ type, payload: { postId } }: any) {
//   try {
//     // console.log('type = ' + type);
//     const response: Promise<any> = yield call(loadPostConverApi, postId);
//     console.log('loadPostConverSaga:', response);
//     yield put(apiOk(type, response));
//   } catch (e) {
//     Utils.HandleException(e, false);
//     yield put(apiErr(type, Utils.GetMessageFromExecption(e)));
//   }
// }

function* setActivePostIdSaga({ type, payload: { activePostInfo, setFrom, wpMode } }: any) {
  try {
    const parm: WpPostInfo = activePostInfo;
    // console.log('setActivePostIdSaga:', setFrom, parm);
    const activePostId = parm.postId;
    if (activePostId) {
      // 20261020 cached info first (was after the conversation): the bottom panel (quill / Join) is decided
      // from the cached youIsMember, so it must be in place before the cached conversation paints
      try {
        let cachedInfo: WpPostInfo | null = null;
        switch (wpMode) {
          case WpModes.Workplace: cachedInfo = yield call(DbUtils.wp_load_post_info, activePostId); break;
          case WpModes.Task: cachedInfo = yield call(DbUtils.wp_load_task_info, activePostId); break;
        }
        if (cachedInfo != null) {
          yield put(setPostInfoOnly(cachedInfo, true));
        }
      } catch (e2) {
        Utils.HandleException(e2, false);
      }

      try {
        // const rs: any[] = yield call(DbUtils.wp_load_post_conver, activePostId);
        let rs: any[] = [];
        switch (wpMode) {
          case WpModes.Workplace: rs = yield call(DbUtils.wp_load_post_conver, activePostId); break;
          case WpModes.Task: rs = yield call(DbUtils.wp_load_task_conver, activePostId); break;
        }
        // console.log('loadPostConverSaga Local:', rs);
        if (rs != null) {
          rs.forEach((ee: any) => {
            ee.bodyHtml = Utils.FixRelativeResourceUrlsForNative(ee.bodyHtml);
          });
          //yield put(apiOk(type, rs));
          yield put(apiOk(type, { wpMode, convers: rs }));
        }
      } catch (e2) {
        Utils.HandleException(e2, false);
      }

      yield put(loadPostInfo(wpMode, activePostId));
      const response: any[] = yield call(loadPostConverApi2, wpMode, activePostId, null, null, WP_CONVER_PAGE_SIZE);
      // console.log('loadPostConverSaga Api:', { type, response });
      (response ?? []).forEach((ee: any) => {
        ee.bodyHtml = Utils.FixRelativeResourceUrlsForNative(ee.bodyHtml);
      });
      //yield put(apiOk(type, response));
      yield put(apiOk(type, { wpMode, convers: response, converHasMore: (response ?? []).length >= WP_CONVER_PAGE_SIZE }));

      // 20250925 Move to save to mem inside conversation
      // try {
      //   DbUtils.wp_load_post_conver(activePostId, response);
      // } catch (e2) {
      //   Utils.HandleException(e2, false);
      // }
    }
  } catch (e) {
    Utils.HandleException(e, false);
    yield put(apiErr(type, Utils.GetMessageFromExecption(e)));
    // 20261021: task not openable for this user (sql-log Step 29) - wipe its cache and close it, if still the open one
    if (Utils.IsTaskNoPermission(e)) {
      const deniedPostId = activePostInfo?.postId;
      if (deniedPostId) yield call(DbUtils.wp_forget_task, deniedPostId);
      let openPostId: string | null | undefined = null;
      openPostId = yield select((state: any) => state.WpSlice.activePostInfo?.postId);
      if (deniedPostId && openPostId === deniedPostId) {
        yield put(setActivePostId2(wpMode, null, null, null, null, null, "Task no permission"));
        alert(e && (e as any).response?.data?.message);
      }
    }
  }
}

function* loadMorePostConverSaga({ type, payload: { wpMode, postId, beforePostDateTime, beforePostId } }: any) {
  try {
    const response: any[] = yield call(loadPostConverApi2, wpMode, postId, beforePostDateTime, beforePostId, WP_CONVER_PAGE_SIZE);
    (response ?? []).forEach((ee: any) => {
      ee.bodyHtml = Utils.FixRelativeResourceUrlsForNative(ee.bodyHtml);
    });
    yield put(apiOk(type, { wpMode, moreConvers: response, converHasMore: (response ?? []).length >= WP_CONVER_PAGE_SIZE }));
  } catch (e) {
    Utils.HandleException(e, false);
    yield put(apiErr(type, Utils.GetMessageFromExecption(e)));
  }
}

function* loadPostInfoSaga({ type, payload: { wpMode, postId } }: any) {
  try {
    if (postId) {
      const response: Promise<any> = yield call(loadPostInfoApi, postId);
      // console.log('loadPostInfoSaga:', response);
      yield put(apiOk(type, response));

      try {
        switch (wpMode) {
          case WpModes.Workplace: yield call(DbUtils.wp_load_post_info, postId, response); break;
          case WpModes.Task: yield call(DbUtils.wp_load_task_info, postId, response); break;
        }
      } catch (e2) {
        Utils.HandleException(e2, false);
      }
    }
  } catch (e) {
    Utils.HandleException(e, false);
    yield put(apiErr(type, Utils.GetMessageFromExecption(e)));
  }
}

function* getRoleUnreadCountSaga({ type, payload: { sendNotification } }: any) {
  try {
    const response: Promise<any> = yield call(getRoleUnreadCountApi, sendNotification);
    if (sendNotification == false) {
      // console.log('getRoleUnreadCountSaga:', response);
      yield put(apiOk(type, response));
    }
  } catch (e) {
    Utils.HandleException(e, false);
    yield put(apiErr(type, Utils.GetMessageFromExecption(e)));
  }
}

// function* setTagUnreadOnSignalRSaga({ type, payload: { tagUnread } }: any) {
//   try {
//     yield put(apiOk(type, tagUnread));
//   } catch (e) {
//     Utils.HandleException(e, false);
//   }
// }

function* loadDllEmployeeSaga({ type, payload: { } }: any) {
  try {
    const response: Promise<any> = yield call(loadDllEmployeeApi);
    yield put(apiOk(type, response));
  } catch (e) {
    Utils.HandleException(e, false);
    yield put(apiErr(type, Utils.GetMessageDividerElement(e)));
  }
}

function* loadTaskDashSaga({ type, payload: { divMode, statusRange1, statusRange2, filterTagId, includeTaskRecurance, rangeFilter, priorityFilter } }: any) {
  try {
    // local cache only holds the unfiltered (year-to-date) dashboard - showing it under a time range or a
    // priority filter would flash wrong numbers, and a filtered result must never overwrite it
    const useLocalCache = filterTagId == null && !rangeFilter && !priorityFilter;

    if (useLocalCache) {
      if (type == WpActionTypes.WP_LOAD_TASK_DASH) {
        const local = localStorage.getItem("tkdsh")
        if (local) {
          try {
            const json = JSON.parse(local);
            yield put(apiOk(type, { isLocal: true, data: json }));
          } catch { }
        }
      }
      // const localByDiv = divMode == "DIV_RSP" ? StorageUtils.TaskDashDivMemRsp : divMode == "DIV_ASG" ? StorageUtils.TaskDashDivMemAsg : divMode == "DIV_REQ" ? StorageUtils.TaskDashDivMemReq : null;
      // if (localByDiv) {
      //   try {
      //     const json = JSON.parse(localByDiv);
      //     yield put(apiOk(type, { isLocal: true, divMode, data: json }));
      //   } catch { }
      // }
    }
    // console.log('loadTaskDashSaga: start');
    if (type == WpActionTypes.WP_LOAD_TASK_DASH) {
      const response: Promise<any> = yield call(loadTaskDashApiV2, statusRange1, statusRange2, filterTagId, includeTaskRecurance, rangeFilter, priorityFilter);
      // console.log('loadTaskDashSaga:', response);
      if (useLocalCache) {
        localStorage.setItem("tkdsh", JSON.stringify(response));
      }
      yield put(apiOk(type, { isLocal: false, data: response }));
    }

    const byDiv: Promise<any> = yield call(loadTaskDashboardByDivApi, divMode, statusRange1, statusRange2, filterTagId, includeTaskRecurance, rangeFilter, priorityFilter);
    // console.log('byDiv:', byDiv);
    if (useLocalCache) {
      const data = JSON.stringify(byDiv);
      if (divMode == "DIV_RSP") StorageUtils.TaskDashDivMemRsp = data;
      else if (divMode == "DIV_ASG") StorageUtils.TaskDashDivMemAsg = data;
      else if (divMode == "DIV_REQ") StorageUtils.TaskDashDivMemReq = data;
    }
    yield put(apiOk(type, { isLocal: false, divMode, byDiv: byDiv }));
  } catch (e) {
    Utils.HandleException(e, false);
    yield put(apiErr(type, Utils.GetMessageDividerElement(e)));
  }
}

function* loadTaskDashRecuranceSaga({ type, payload: { } }: any) {
  try {
    const local = StorageUtils.DashboardTaskRecuranceMem;
    if (local) {
      try {
        const json = JSON.parse(local);
        yield put(apiOk(type, { isLocal: true, data: json }));
      } catch { }
    }

    // console.log('loadTaskDashSaga: start');
    const response: Promise<any> = yield call(loadTaskDashRecuranceApi);
    StorageUtils.DashboardTaskRecuranceMem = JSON.stringify(response);
    yield put(apiOk(type, { isLocal: false, data: response }));
  } catch (e) {
    Utils.HandleException(e, false);
    yield put(apiErr(type, Utils.GetMessageDividerElement(e)));
  }
}

function* loadTaskDashTagsSaga({ type, payload: { includeTaskRecurance } }: any) {
  try {
    const local = localStorage.getItem("tkdshtags")
    if (local) {
      try {
        const json = JSON.parse(local);
        yield put(apiOk(type, { isLocal: true, data: json }));
      } catch { }
    }
    // console.log('loadTaskDashSaga: start');
    const response: Promise<any> = yield call(loadTaskDashTagsApiV2, includeTaskRecurance);
    // console.log('loadTaskDashTagsSaga:', response);
    localStorage.setItem("tkdshtags", JSON.stringify(response));
    yield put(apiOk(type, { isLocal: false, data: response }));
  } catch (e) {
    Utils.HandleException(e, false);
    yield put(apiErr(type, Utils.GetMessageDividerElement(e)));
  }
}



function* loadTaskDashStatusRangeSaga({ type, payload: { statusRange1, statusRange2, filterTagId, includeTaskRecurance } }: any) {
  try {
    const response: Promise<any> = yield call(loadTaskDashStatusrangeV2Api, statusRange1, statusRange2, filterTagId, includeTaskRecurance);
    // console.log('loadTaskDashStatusrangeApi:', response);
    yield put(apiOk(type, response));
  } catch (e) {
    Utils.HandleException(e, false);
    yield put(apiErr(type, Utils.GetMessageDividerElement(e)));
  }
}

function* loadSubTaskSaga({ type, payload: { parentTaskId } }: any) {
  try {
    const response: Promise<any> = yield call(loadSubTaskApi, parentTaskId);
    console.log('loadSubTaskApi:', response);
    yield put(apiOk(type, { parentTaskId, response }));
  } catch (e) {
    Utils.HandleException(e, false);
    yield put(apiErr(type, Utils.GetMessageDividerElement(e)));
  }
}

function* tagMasterCatLoadSaga({ type, payload: { } }: any) {
  try {
    const response: Promise<any> = yield call(tagMasterCatLoadApi);
    yield put(apiOk(type, { response }));
  } catch (e) {
    Utils.HandleException(e, false);
    yield put(apiErr(type, Utils.GetMessageDividerElement(e)));
  }
}

// 20261019 Pre-load the conversation of every UNREAD topic in redux (titles + titlesTk) into IndexedDB, so clicking it paints from cache.
// Kept light on the backend: one request at a time with a gap, a cap per pass, skipped when the cache was already fetched for the
// title's current lastChatDate (stamp), a per-topic cooldown, and paused while the user's own click is loading or the app is hidden.
const PREFETCH_FIRST_DELAY_MS = 5000; // let the login request burst settle first
const PREFETCH_THROTTLE_MS = 3000;
const PREFETCH_GAP_MS = 400;
const PREFETCH_MAX_PER_PASS = 20;
const PREFETCH_COOLDOWN_MS = 60000;
const prefetchLastAt = new Map<string, number>();
let prefetchRetryPending = false;

const TITLE_LOAD_TYPES = [WpActionTypes.LOAD_POST_TITLE_WP, WpActionTypes.LOAD_POST_TITLE_TK, WpActionTypes.LOAD_MORE_POST_TITLE_WP, WpActionTypes.LOAD_MORE_POST_TITLE_TK];
const isPrefetchTrigger = (a: any) =>
  a.type == WpActionTypes.SET_POST_INFO_ON_SIGNALR
  || a.type == WpActionTypes.PREFETCH_UNREAD_CONVER
  || (a.type == WpActionTypes.API_OK && TITLE_LOAD_TYPES.includes(a.payload?.type));

// a missing/unparseable lastChatDate compares as its raw string, so a topic with no last-post time is still fetched once, then skipped until it changes
const sameChatDate = (a: any, b: any) => {
  const ta = a ? new Date(a).getTime() : NaN;
  const tb = b ? new Date(b).getTime() : NaN;
  return (isNaN(ta) || isNaN(tb)) ? String(a ?? "") === String(b ?? "") : ta === tb;
};

function* prefetchUnreadConverPass(): Generator<any, void, any> {
  let fetched = 0;
  let deferred = false;
  const snapshot: any = yield select((state: any) => state.WpSlice);
  const candidates: { wpMode: WpModes, postId: string, lastChatDate: string }[] = [
    ...(snapshot.titles ?? []).map((t: any) => ({ wpMode: WpModes.Workplace, t })),
    ...(snapshot.titlesTk ?? []).map((t: any) => ({ wpMode: WpModes.Task, t })),
  ]
    .filter(c => (c.t.unread ?? 0) > 0)
    .sort((a, b) => (new Date(b.t.lastChatDate).getTime() || 0) - (new Date(a.t.lastChatDate).getTime() || 0))
    .map(c => ({ wpMode: c.wpMode, postId: c.t.postId, lastChatDate: c.t.lastChatDate }));

  for (const c of candidates) {
    if (fetched >= PREFETCH_MAX_PER_PASS) { deferred = true; break; }
    if (typeof document !== "undefined" && document.hidden) return; // the next title change after resume starts a new pass

    // the user's own click goes first
    while ((yield select((state: any) => state.WpSlice.converLoading))) yield delay(500);

    const wp: any = yield select((state: any) => state.WpSlice);
    if (wp.activePostInfo?.postId === c.postId) continue; // the open post keeps its own cache (WorkplaceContent save effect)
    const list = c.wpMode == WpModes.Task ? wp.titlesTk : wp.titles;
    const cur = (list ?? []).find((t: any) => t.postId === c.postId);
    if (!cur || (cur.unread ?? 0) <= 0) continue; // read meanwhile

    const key = `${c.wpMode}_${c.postId}`;
    const lastAt = prefetchLastAt.get(key) ?? 0;
    if (Date.now() - lastAt < PREFETCH_COOLDOWN_MS) { deferred = true; continue; }

    try {
      const stamp: any = yield call(DbUtils.wp_load_conver_stamp, c.wpMode, c.postId);
      if (stamp && sameChatDate(stamp.lcd, cur.lastChatDate)) continue; // cache already has this topic's latest message

      const lcdAtFetch = cur.lastChatDate; // if a newer message lands mid-fetch, the stamp stays older and the next pass refetches
      const response: any[] = yield call(loadPostConverApi2, c.wpMode, c.postId, null, null, WP_CONVER_PAGE_SIZE);
      prefetchLastAt.set(key, Date.now());
      fetched++;

      const after: any = yield select((state: any) => state.WpSlice.activePostInfo?.postId);
      if (after !== c.postId && Array.isArray(response)) { // opened while fetching -> its own load owns the cache
        response.forEach((ee: any) => { ee.bodyHtml = Utils.FixRelativeResourceUrlsForNative(ee.bodyHtml); });
        if (c.wpMode == WpModes.Task) yield call(DbUtils.wp_load_task_conver, c.postId, response);
        else yield call(DbUtils.wp_load_post_conver, c.postId, response);
        yield call(DbUtils.wp_load_conver_stamp, c.wpMode, c.postId, { lcd: lcdAtFetch, at: Date.now() });
      }
    } catch (e) {
      if (Utils.IsTaskNoPermission(e)) { // 20261021: not openable for this user - skip it, keep prefetching the rest
        prefetchLastAt.set(key, Date.now());
        yield call(DbUtils.wp_forget_task, c.postId);
        continue;
      }
      Utils.HandleException(e, false);
      return; // backend trouble - stop this pass rather than keep hitting it
    }
    yield delay(PREFETCH_GAP_MS);
  }

  // topics skipped by the cooldown/cap get one follow-up pass later, even if no title changes meanwhile
  if (deferred && !prefetchRetryPending) {
    prefetchRetryPending = true;
    yield fork(function* () {
      yield delay(PREFETCH_COOLDOWN_MS);
      prefetchRetryPending = false;
      yield put({ type: WpActionTypes.PREFETCH_UNREAD_CONVER, payload: {} });
    });
  }
}

export function* prefetchUnreadConverWatch(): Generator<any, void, any> {
  // sliding(1): any number of title changes while a pass is running collapse into exactly one more pass
  const chan = yield actionChannel(isPrefetchTrigger, buffers.sliding(1));
  let first = true;
  while (true) {
    yield take(chan);
    yield delay(first ? PREFETCH_FIRST_DELAY_MS : PREFETCH_THROTTLE_MS);
    first = false;
    try {
      yield call(prefetchUnreadConverPass);
    } catch (e) {
      Utils.HandleException(e, false);
    }
  }
}

function* syncTitleUnreadToDbSaga({ type, payload }: any) {
  try {
    switch (type) {
      case WpActionTypes.UPDATE_POST_UNREAD_COUNT:
        yield call(DbUtils.wp_patch_title_unread, payload.wpMode, [payload.postId], payload.unreadCount ?? 0); break;
      case WpActionTypes.SET_UNREAD:
        yield call(DbUtils.wp_patch_title_unread, payload.wpMode, [payload.postId], payload.unread ?? 0); break;
      case WpActionTypes.MARK_AS_READ:
        yield call(DbUtils.wp_patch_title_unread, payload.wpMode, String(payload.postIds ?? "").split('|').filter(Boolean), 0); break;
      case WpActionTypes.READ_POST_LOCAL: // 20261020
        yield call(DbUtils.wp_patch_title_unread, payload.wpMode, [payload.postId], 0); break;
    }
  } catch (e) {
    Utils.HandleException(e, false);
  }
}

export function* syncTitleUnreadToDbWatch() {
  yield takeEvery([WpActionTypes.UPDATE_POST_UNREAD_COUNT, WpActionTypes.SET_UNREAD, WpActionTypes.MARK_AS_READ, WpActionTypes.READ_POST_LOCAL], syncTitleUnreadToDbSaga);
}

/* watched function */
export function* loadPostTitleWatch() {
  // yield takeLatest(WpActionTypes.LOAD_POST_TITLE, loadPostTitleSaga);
  yield takeLatest(WpActionTypes.LOAD_POST_TITLE_WP, loadPostTitleSaga);
  yield takeLatest(WpActionTypes.LOAD_POST_TITLE_TK, loadPostTitleSaga);
}

export function* loadMorePostTitleWatch() {
  yield takeLatest(WpActionTypes.LOAD_MORE_POST_TITLE_WP, loadMorePostTitleSaga);
  yield takeLatest(WpActionTypes.LOAD_MORE_POST_TITLE_TK, loadMorePostTitleSaga);
}

// export function* loadPostConverWatch() {
//   yield takeLatest(WpActionTypes.LOAD_POST_CONVER, loadPostConverSaga);
// }

export function* setActivePostIdWatch() {
  //yield takeLatest(WpActionTypes.SET_ACTIVE_POSTID, setActivePostIdSaga);
  yield takeLatest(WpActionTypes.SET_ACTIVE_POSTID2, setActivePostIdSaga);
}

export function* loadMorePostConverWatch() {
  yield takeLatest(WpActionTypes.LOAD_MORE_POST_CONVER, loadMorePostConverSaga);
}

export function* loadPostInfoWatch() {
  yield takeLatest(WpActionTypes.LOAD_POST_INFO2, loadPostInfoSaga);
}

export function* getRoleUnreadCountWatch() {
  yield takeLatest(WpActionTypes.GET_ROLE_UNREAD_COUNT, getRoleUnreadCountSaga);
}

// export function* setTagUnreadOnSignalRWatch(){
//   yield takeEvery(WpActionTypes.TAG_UNREAD_ON_SIGNALR, setTagUnreadOnSignalRSaga);
// }

export function* loadDllEmployeeWatch() {
  yield takeLatest(WpActionTypes.LOAD_DLL_EMPLOYEE, loadDllEmployeeSaga);
}

export function* loadTaskDashWatch() {
  yield takeLatest(WpActionTypes.WP_LOAD_TASK_DASH, loadTaskDashSaga);
}

export function* loadTaskDashWatchByDiv() {
  yield takeLatest(WpActionTypes.WP_LOAD_TASK_DASHBOARD_BY_DIV, loadTaskDashSaga);
}


export function* loadTaskDashRecuranceWatch() {
  yield takeLatest(WpActionTypes.WP_LOAD_TASK_DASH_RECURANCE, loadTaskDashRecuranceSaga);
}

export function* loadTaskDashTagsWatch() {
  yield takeLatest(WpActionTypes.WP_LOAD_TASK_DASH_TAGS, loadTaskDashTagsSaga);
}

export function* loadTaskDashStatusRangeWatch() {
  yield takeLatest(WpActionTypes.WP_LOAD_TASK_DASH_STATUSRANGE, loadTaskDashStatusRangeSaga);
}

export function* loadSubTaskWatch() {
  yield takeEvery(WpActionTypes.WP_LOAD_SUB_TASK, loadSubTaskSaga);
}

export function* tagMasterCatLoadWatch() {
  yield takeLatest(WpActionTypes.WP_TAG_MASTER_CAT_LOAD, tagMasterCatLoadSaga);
}






/* main function */
function* wpSaga() {
  yield all([
    fork(loadPostTitleWatch),
    fork(loadMorePostTitleWatch),
    fork(setActivePostIdWatch),
    fork(loadMorePostConverWatch),
    fork(loadPostInfoWatch),
    fork(getRoleUnreadCountWatch),
    fork(loadDllEmployeeWatch),
    fork(loadTaskDashWatch),
    fork(loadTaskDashWatchByDiv),
    fork(loadTaskDashRecuranceWatch),
    fork(loadTaskDashStatusRangeWatch),
    fork(loadSubTaskWatch),
    fork(loadTaskDashTagsWatch),
    fork(tagMasterCatLoadWatch),
    fork(prefetchUnreadConverWatch),
    fork(syncTitleUnreadToDbWatch),
    // fork(setTagUnreadOnSignalRWatch),
  ]);
}

export default wpSaga;